import { generateCustomerId } from '@eurostar/generate-customer-id';

import config from './config';

const configEnv = config('CONFIG_ENV');
const appName = config('APP_NAME');

export const getLaunchDarklyEnvironment = () => {
  switch (configEnv) {
    case 'production':
      return 'Production';
    case 'staging':
      return 'Staging';
    case 'test':
      return 'Test';
    default:
      return 'Development';
  }
};

export const getLaunchDarklyContext = async (userIdentifier, additionalUserContext = {}, additionalAppContext = {}) => {
  // Generate SHA-256 hash of userIdentifier
  const userIdentifierHash = await generateCustomerId(userIdentifier);

  return {
    kind: 'user',
    key: `${userIdentifierHash}:app:${appName}`,
    anonymous: false,
    user: {
      ...(additionalUserContext && { ...additionalUserContext })
    },
    app: {
      key: appName,
      environment: getLaunchDarklyEnvironment(),
      ...(additionalAppContext && { ...additionalAppContext })
    }
  };
};
